import {
  ProductFormData,
  ProductUpdatePayload,
} from '../interfaces/productInterface';

type FormProductEditFactoryInput = {
  formData: ProductFormData;
};

export function formProductEditFactory({
  formData,
}: FormProductEditFactoryInput): ProductUpdatePayload {
  const warrantyDays = Number(String(formData.warrantyDays).replace(/\D/g, ''));
  const providerId = Number(formData.providerId);
  const categories = formData.categories
    .map(categoryId => Number(categoryId))
    .filter(categoryId => !isNaN(categoryId));

  if (isNaN(warrantyDays)) {
    throw new Error('Garantia em dias deve ser um numero valido');
  }

  if (isNaN(providerId)) {
    throw new Error('Adquirente deve ser um numero valido');
  }

  const name = String(formData.name).trim();

  return {
    name,
    publicName: name,
    warrantyDays,
    providerId,
    categories,
  };
}
